export var historicalViewMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                loancode: item.loancode,
                loantype: item.loantype,
                roi: item.roi,
                sanctionamt: item.sanctionamt,
                startdate: item.startdate,
                enddate: item.enddate,
                pfreceived: item.pfreceived,
                disbursementamt: item.disbursementamt,
                detailsexercisedesops: item.detailsexercisedesops,
                interesT_RECEIVED: item.interesT_RECEIVED,
                secureD_UNSECURED: item.secureD_UNSECURED,
            };
        });
    }
    return result;
};
